import { toast } from "sonner";

// Native share with graceful clipboard fallback
export async function shareLink({ title, text, url }) {
  const shareUrl = url || window.location.origin;
  try {
    if (navigator.share) {
      await navigator.share({ title, text, url: shareUrl });
      return;
    }
  } catch (e) {
    if (e && e.name === "AbortError") return; // user cancelled
  }
  try {
    await navigator.clipboard.writeText(shareUrl);
    toast.success("Link copied to clipboard", { description: shareUrl });
  } catch {
    toast("Share this link", { description: shareUrl });
  }
}

export function shareReferral(code) {
  const url = `https://getwyvn.com/?ref=${code}`;
  return shareLink({
    title: "Get WYVN — win daily.",
    text: "I'm using WYVN — one calm, intelligent home where your wins in training, nutrition and mind are woven together with the people who move with you. Join free with my code: you get a 30-day free trial, and I get 30 free days of my current plan when you subscribe. Get WYVN at getwyvn.com",
    url,
  });
}
